
import LayoutContainer from "../../../components/Containers/LayoutContainer"
import '@fortawesome/fontawesome-free/css/all.min.css';
import React, { useEffect, useRef, useState } from "react"
import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown";
import { postDetails, postMultipartDetails } from "../../../services/http/http.service";
import APIList from "../../../utils/constants/APIList";
import InputField from "../../../components/InputField/InputField";
import CustomButton from "../../../components/CustomButton/CustomButton";
import "./AddGallery.scss";
import encrypt from "../../../utils/helpers/encrypt";
import { validateUploadedFile } from "../../../utils/helpers/validateFileUpload";
import { useAppDispatch } from "../../../store/storeRequests";
import { hideLoader, showLoader } from "../../../store/Loader/loader.slice";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { ArrowLeftSquareFill } from "react-bootstrap-icons";
import { customStyles, addGalleryDropdownStyle, customSingleSelectStyles} from "../../../utils/constants/CustomStyles.constants";
import { hideToast, showToast } from "../../../store/Toast/toast.slice";

interface Folder {
  id: number;
  folder_name: string;
}

interface FormData {
  folder_name:string
  mediafiles: File[];
}

const AddGallery: React.FunctionComponent = () => {
  const navigate = useNavigate();
  // const [folders, setFolders] = useState<[]>([]);
  const [folders, setFolders] = useState<Folder[]>([]);
  const cmpMounted = useRef(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [files, setFiles] = useState<any []>([]);
  const [filePreview, setFilePreview] = useState<(string | File)[]>([]);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [addFileButtonVisible, setAddFileButtonVisible] = useState(false);
  const [hoveredFileIndex, setHoveredFileIndex] = useState(-1);
  const [selectedValue, setSelectedValue] = useState<any>({ id: 0, name: "Select Folder" })
  const dispatch = useAppDispatch();
  const [folderError, setFolderError] = useState(false);
  const [fileError, setFileError] = useState("")

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchGetAllFolder();
  }, []);

  const fetchGetAllFolder = async () => {
    try {
      dispatch(showLoader('Loading data...'));
      const response = await postDetails(APIList.folder_list, {});
      // console.log(response.data)
      setFolders(response.data || []);
    } catch (error) {
      console.error("Error fetching folders:", error);
      dispatch(showToast("Error fetching folders."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const options = folders.map((item:any) => ({ value: item.id, label: item.folder_name
  }));

  // const handleDropdownClick = (ev: any, item: {id:number; folder_name: string; value: number}) => {
  //   console.log(item)
  //   setSelectedValue(item); 
  // };

  const handleDropdownChange = (selectedOption: any | null) => {
    // console.log(selectedOption)
    setSelectedValue(selectedOption);
    if (selectedOption) {
      setFolderError(false);
    }
  };

  const addGallery = async () => {
    if (selectedValue.id === 0 && files.length === 0) {
      dispatch(showToast( "Please Select Folder and Upload Media"));
      setTimeout(() => dispatch(hideToast()), 3000);
      setFolderError(true);
      setFileError("This field is required")
      return;
    }
   
    if(selectedValue.id === 0){
      setFolderError(true);
      dispatch(showToast( "Please Select Folder"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return
    }

    if(files.length === 0){
      setFileError("This field is required")
      dispatch(showToast( "Please Upload Media"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return
    }
    
   
    try {
      dispatch(showLoader("Loading data..."));
      const formData = new FormData();
      formData.append("data", encrypt({ folderId: selectedValue.value }));
      for (let i = 0; i < files.length; i++) {
        formData.append("mediafiles", files[i]);
      }
      const response = await postMultipartDetails(APIList.Add_media, formData);
      // console.log(response)

      if(response.statusCode === 200){
        dispatch(showToast("Media uploaded successfully."));
        setTimeout(() => dispatch(hideToast()), 3000);
        navigate("/gallery");
      } else{
        dispatch(showToast("Some error occurred while uploading media."));
        setTimeout(() => dispatch(hideToast()), 3000);
      }

    } catch (error) {
      console.error("Error submitting gallery:", error);
      dispatch(showToast("An unexpected error occurred. Please try again later."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };
  
  
  const filePreviewStyle = {
    width: "8.500rem",
    height: "9rem",
    padding: "0.200rem",
    margin: "0.800rem 0.300rem",
    borderRadius: "0.500rem",
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);

    const updatedFilePreviews = [...filePreview];
    updatedFilePreviews.splice(index, 1);

    setFiles(updatedFiles);
    setFilePreview(updatedFilePreviews);

    if (updatedFiles.length > 0 && updatedFiles.length < MAX_FILES ) {
      setAddFileButtonVisible(true);
    }
  };


  const MAX_FILES = 25;

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files;
  
    if (selectedFiles) {
      const currentFileCount = files.length;
      const totalFileCount = currentFileCount + selectedFiles.length;
  
      // Check if total files exceed 10
      if (totalFileCount > MAX_FILES) {
        dispatch(showToast(`You can only upload a maximum of ${MAX_FILES} files.`));
      setTimeout(() => dispatch(hideToast()), 3000);
        event.target.value = ""; // Reset input value to prevent further uploads
        return;
      }
  
      // const maxImageSize = 10.1 * 1024 * 1024; 
      // const maxVideoSize = 25.1 * 1024 * 1024; 
      // const maxPdfSize = 20.1 * 1024 * 1024;
      const allowedFileTypes = [
        "image/jpeg",
        "image/png",
        "video/mp4",
        "application/pdf",
      ];
  
      const newFilePreviews: (string | File)[] = [];
      const validFiles: File[] = [];
  
      // for (const file of Array.from(selectedFiles)) {
      //   if (file.type.startsWith("video/")) {
      //     if (file.size > maxVideoSize) {
      //       alert(`Video file "${file.name}" exceeds the 25 MB size limit.`);
      //       continue;
      //     }
      //     newFilePreviews.push(file);
      //     validFiles.push(file);
      //   } else if (file.type.startsWith("image/")) {
      //     if (file.size > maxImageSize) {
      //       alert(`Image file "${file.name}" exceeds the 10 MB size limit.`);
      //       continue;
      //     }
      //     newFilePreviews.push(URL.createObjectURL(file));
      //     validFiles.push(file);
      //   } else if (file.type === "application/pdf") {
      //     if (file.size > maxPdfSize) {
      //       alert(`PDF file "${file.name}" exceeds the 20 MB size limit.`);
      //       continue;
      //     }
      //     newFilePreviews.push(file);
      //     validFiles.push(file);
      //   } else {
      //     alert("Invalid file type. Only images, videos, and PDFs are allowed.");
      //     continue;
      //   }
      // }

      for (const file of Array.from(selectedFiles)) {
        // Validate real extension + reject deceptive double-extension names
        // (e.g. file.php.png, file.png.svg) before the MIME check.
        const validation = validateUploadedFile(
          file,
          {
            png: ["image/png"],
            jpg: ["image/jpeg", "image/jpg"],
            jpeg: ["image/jpeg", "image/jpg"],
            mp4: ["video/mp4"],
            pdf: ["application/pdf"],
          },
          "PNG, JPG, MP4 and PDF"
        );
        if (!validation.valid) {
          dispatch(showToast(`Invalid file "${file.name}". ${validation.message}`));
          setTimeout(() => dispatch(hideToast()), 3000);
          continue; // Skip invalid files
        }

        // Check for valid file types first
        if (!allowedFileTypes.includes(file.type)) {
          dispatch(showToast(`Invalid file type "${file.name}". Only PNG, JPG, MP4, and PDF are allowed.`));
          setTimeout(() => dispatch(hideToast()), 3000);
          continue; // Skip invalid files
        }
  
        // Check for valid file sizes
        // if (file.type.startsWith("video/")) {
        //   if (file.size > maxVideoSize) {
        //     dispatch(showToast(`Video file "${file.name}" exceeds the 25 MB size limit.`));
        //     setTimeout(() => dispatch(hideToast()), 3000);
        //     continue;
        //   }
        // } else if (file.type.startsWith("image/")) {
        //   if (file.size > maxImageSize) {
        //     dispatch(showToast(`Image file "${file.name}" exceeds the 10 MB size limit.`));
        //     setTimeout(() => dispatch(hideToast()), 3000);
        //     continue;
        //   }
        // } else if (file.type === "application/pdf") {
        //   if (file.size > maxPdfSize) {
        //     dispatch(showToast(`PDF file "${file.name}" exceeds the 20 MB size limit.`));
        //     setTimeout(() => dispatch(hideToast()), 3000);
        //     continue;
        //   }
        // }
  
        // If the file passes all checks, add it to the valid files
        validFiles.push(file);
  
        // For images, generate object URL for preview
        if (file.type.startsWith("image/")) {
          newFilePreviews.push(URL.createObjectURL(file));
        } else {
          newFilePreviews.push(file); // For videos and PDFs, just push the file itself
        }
      }
  
      const updatedFiles = [...files, ...validFiles];
      setFiles(updatedFiles);
      const updatedFilePreviews = [...filePreview, ...newFilePreviews];
      setFilePreview(updatedFilePreviews);
  
      // Ensure that the file input gets reset after upload
      event.target.value = "";
      setAddFileButtonVisible(updatedFiles.length > 0 && updatedFiles.length < MAX_FILES);
      setFileError("")
    }
  };

  // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const selectedFiles = event.target.files;
  //   console.log(selectedFiles)
  //   if (selectedFiles) {
  //     if (selectedFiles.length >= 25) {
  //       alert("You can only upload a maximum of 25 files.");
  //       event.target.value = "";
  //       return;
  //     }

  //     const maxImageSize = 10.1 * 1024 * 1024; 
  //     const maxVideoSize = 25.1 * 1024 * 1024; 
  //     const allowedFileTypes = ["image/jpeg", "image/png", "video/mp4"];
  
  //     const newFilePreviews: (string | File)[] = [];
  //     const validFiles: File[] = [];
  
  //     for (const file of Array.from(selectedFiles)) {

        
  //       if (!allowedFileTypes.includes(file.type)) {
  //         alert(`File ${file.name} is not a supported type (JPG, PNG, MP4).`);
  //         event.target.value = ""; 
  //         return;
  //       }

  //       const maxSize = file.type.startsWith("image/") ? maxImageSize : maxVideoSize;

  //       if (file.size > maxSize) {
  //         alert(`File ${file.name} exceeds the allowed size.`);
  //         event.target.value = ""; 
  //         return;
  //       }

  //       if (file.type.startsWith("video/")) {
  //         newFilePreviews.push(file); 
  //       } else if (file.type.startsWith("image/")) {
  //         newFilePreviews.push(URL.createObjectURL(file)); 
  //       }
  
  //       validFiles.push(file); 
  //     }
  //       const updatedFiles = [...files, ...validFiles];
  //     setFiles(updatedFiles);
  
  //     const updatedFilePreviews = [...filePreview, ...newFilePreviews];
  //     setFilePreview(updatedFilePreviews);
  
  //     setFileInputKey(fileInputKey + 1); 
  //     setAddFileButtonVisible(updatedFiles.length < 25); 
  //   }
  // };
  
  


// const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//   const selectedFiles = event.target.files;
//   if (selectedFiles) {
//     if (selectedFiles.length > 15) {
//       alert("You can only upload a maximum of 15 files.");
//       event.target.value = ""; 
//       return;
//     }
//     const newFilePreviews: (string | File)[] = [];
//     const validFiles: File[] = [];

//     for (const file of Array.from(selectedFiles)) {
//       if (file.type.startsWith("video/")) {
//         newFilePreviews.push(file);  
//         validFiles.push(file);     
//       } else if (file.type.startsWith("image/")) {
//         newFilePreviews.push(URL.createObjectURL(file)); 
//         validFiles.push(file);    
//       } else {
//         alert("Invalid file type. Only images and videos are allowed.");
//         continue; 
//       }
//     }
//     const updatedFiles = [...files, ...validFiles];
//     setFiles(updatedFiles);  
//     const updatedFilePreviews = [...filePreview, ...newFilePreviews];
//     setFilePreview(updatedFilePreviews);  
//     setFileInputKey(fileInputKey + 1); 
//     event.target.value = "";  
//     setAddFileButtonVisible(updatedFiles.length < 15);
//   }
// };
const customFilterOption = (option:any, inputValue:any) => {

  if (!inputValue) {
    return true;
  }

  // Customize the filtering logic to match only based on numeric or alphabetic characters
  const input = inputValue.toLowerCase();
  const optionLabel = option.label.toLowerCase();

  // Only match the input with exact numeric values or specific letters
  return optionLabel.includes(input) && /\d*$/.test(input) === /\d*$/.test(optionLabel);
};

const buttons = [
  {
      label: "Back to Media List",
      theme: "warning",
      icon: <ArrowLeftSquareFill />,    
      onClick: ()=> navigate("/gallery"),
  },
]

  return (
    <LayoutContainer title="living-responsibility">
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>Add Media
          </h2>
          <PageHeader buttons={buttons} />
      </div>
      <div className="card mx-3 mt-3 card-area"
      style={{
        border: "none"
      }}
      >
        <div className="card-body">
          <div className="mb-2">
           <div className="mb-2">
        {/* <CustomDropdown
          currentValue={selectedValue}
          // currentValue={selectedValue}
          menuItems={folders || []} 
          onClick={handleDropdownClick}
          label="Select Folder"
          menuItemKey="folder_name"
          type="folder"
          required={true}
          searchable={false}

        /> */}
        <div className="mb-2" style={{height: "84px"}}>
              <label htmlFor="folderSelect">Select Folder <span className="text-danger">*</span></label>
              <Select
                id="folderSelect"
                options={options}
                value={selectedValue}
                styles={addGalleryDropdownStyle}
                onChange={handleDropdownChange}
                // getOptionLabel={(option: Folder) => option.folder_name}
                // getOptionValue={(option: Folder) => option.id.toString()}
                placeholder="Select Folder"
                filterOption={customFilterOption}
                isSearchable={true}
                required
              />
               {folderError && (
                  <p className="error-text fw-bold font-12 mt-1">This field is required.</p> // Validation message
                )}
            </div>
      </div>
          </div>
          <div className="my-3">
            <div className="my-4 d-flex flex-column align-items-md-center flex-md-row justify-content-md-between">
              <div>
                <p className="mb-1">Upload Your Media <span className="text-danger">*</span></p>
               
              </div>
              <div>
                <p>MaxFile : 25</p>
              </div>
            </div>

            <div className="upload_file_area">
              <div className="custom-file-input">
                <input
                  type="file"
                  id="fileUpload"
                  key={fileInputKey}
                  multiple
                  accept=".jpg, .png, .mp4, .jpeg"
                  // accept="image/png,image/jpeg"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <div className="file-previews" style={{ display: "flex" }}>
                  {filePreview.length > 0 ? null : (
                    <label htmlFor="fileUpload" id="custom-file-label">
                      <p id="drop_file">Drop file here to upload</p>
                    </label>
                  )}
                  {filePreview.map((preview, index) => (
                    <div
                      key={index}
                      className="file-preview"
                      onMouseEnter={() => setHoveredFileIndex(index)}
                      onMouseLeave={() => setHoveredFileIndex(-1)}
                    >
                      {typeof preview === "string" ? (
                        <div
                          style={{
                            ...filePreviewStyle,
                            position: "relative",
                          }}
                        >
                          <img
                            src={preview}
                            alt={`File ${index}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "1rem",
                            }}
                          />

                        </div>
                      ) : (
                        <div
                          style={{
                            ...filePreviewStyle,
                            position: "relative",
                          }}
                        >
                          <video
                            controls
                            width="100%"
                            height="100%"
                            style={{ borderRadius: "1rem" }}
                          >
                            <source
                              src={URL.createObjectURL(preview)}
                              type="video/mp4"
                            />
                          </video>

                        </div>
                      )}
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleRemoveFile(index)}
                      >
                        Delete
                      </button>
                    </div>
                  ))}
                </div>
                <div className="btn-add-new-file">
                  {addFileButtonVisible ? (
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                        const fileUpload =
                          document.getElementById("fileUpload");
                        if (fileUpload) {
                          fileUpload.click();
                        }
                        event.currentTarget.blur();
                      }}
                    >
                      Add File
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
            <div style={{height: "50px"}}>
            <p className="my-2 font-size">
                Only JPG, PNG,  MP4 file types are supported.
                 {/* Maximum Image size is 10MB and Video size is 25MB. */}
              </p>
              { fileError && <p className="error-text fw-bold font-12" >{fileError}</p>}
              </div>
          </div>


          <div className="my-2 col-2 add-button">
            <CustomButton theme="yellow" type="button" size="md" onClick={addGallery}>
              <span className="d-flex align-items-center justify-content-center font-size-submit gap-2" >Submit </span>
            </CustomButton>
          </div>

        </div>
      </div>

    </LayoutContainer>
  );
};


export default AddGallery;


